import { defineComponent } from 'vue';

import styles from './index.module.scss';
import xssInstance from '@dts/shared/src/utils/xss';

const Notifiy = defineComponent({
  props: {
    notification: {
      type: Object,
      require: true,
      default: () => {},
    },
  },

  emits: ['update:showNotificationDrawer', 'clickGotit'],
  setup: (props, context) => {
    return () => (
      <>
        <div class={styles.notification}>
          <div
            class={styles.notificationContent}
            v-html={xssInstance.process(props?.notification?.message)}
          ></div>
        </div>
      </>
    );
  },
});
export default Notifiy;
